export default __webpack_public_path__ + "static/media/rezRate.61f41304.gif";